export interface UpdateCollectionAndUserCheckRequest {
  id: string
  numberOfBooksCheck: string
  appendixCheck: string
  unregisteredCheck: string
  identificationCheck: string
  lendExtensionCheck: string
  reserveExtensionCheck: string
  delayExtensionCheck: string
  dueDateType: string
  extendDueDateType: string
  extendAdditionalType: string
  revision: number
}

export function UpdateCollectionAndUserCheckRequestToJSON(
  value: UpdateCollectionAndUserCheckRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    number_of_books_check:
      value.numberOfBooksCheck !== '' ? value.numberOfBooksCheck : undefined,
    appendix_check:
      value.appendixCheck !== '' ? value.appendixCheck : undefined,
    unregistered_check:
      value.unregisteredCheck !== '' ? value.unregisteredCheck : undefined,
    identification_check:
      value.identificationCheck !== '' ? value.identificationCheck : undefined,
    lend_extension_check:
      value.lendExtensionCheck !== '' ? value.lendExtensionCheck : undefined,
    reserve_extension_check:
      value.reserveExtensionCheck !== ''
        ? value.reserveExtensionCheck
        : undefined,
    delay_extension_check:
      value.delayExtensionCheck !== '' ? value.delayExtensionCheck : undefined,
    due_date_type: value.dueDateType !== '' ? value.dueDateType : undefined,
    extend_due_date_type:
      value.extendDueDateType !== '' ? value.extendDueDateType : undefined,
    extend_additional_type:
      value.extendAdditionalType !== ''
        ? value.extendAdditionalType
        : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
